export const LANGUAGES = [
  { label: 'English', languageCode: 'en' },
  { label: 'German', languageCode: 'de' },
  { label: 'Spanish', languageCode: 'es' },
  { label: 'French', languageCode: 'fr' },
  { label: 'Portuguese', languageCode: 'pt' },
  { label: 'Russian', languageCode: 'ru' }
]

export const MAX_MESSAGE_CHARACTERS_LIMIT = 200
export const DEFAULT_LIMIT = 20

export const S3_BUCKET_ENDPOINT = 'https://gs-custom-games-storage.s3.amazonaws.com'

/* ==========================================================================
  HTTP Method Types
========================================================================== */
export const METHOD_TYPES = {
  get: 'get',
  post: 'post',
  put: 'put',
  delete: 'delete',
  patch: 'patch'
}
export const getCurrencySymbol = (code) => {
  const countrySymbols = {
    USD: '$'
  }
  return countrySymbols?.[code] || countrySymbols.USD
}
/* ==========================================================================
LocalStorage / Cookie data
========================================================================== */
export const TOKEN = 'authToken'
export const LANGUAGE = 'operator_language'
export const OPERATOR_ID = 'operator_id'
export const ROLE = 'operator_role'

/* ==========================================================================
Operator Roles
========================================================================== */
export const OPERATOR_ROLES = {
  operator: 'OPERATOR',
  operatorUser: 'OPERATOR_USER'
}

/* ==========================================================================
Loader types
========================================================================== */
export const LOADER = {
  BUTTON: 'button',
  CONTENT: 'content',
  TABLE_CELL: 'tableCell'
}

/* ==========================================================================
Loader types
========================================================================== */
export const LOADER_TYPE = {
  SCALE: 'scale',
  PULSE: 'pulse'
}

/* ==========================================================================
  TOASTER / NOTIFICATION Types
========================================================================== */
export const TOASTER_TYPE = {
  success: 'success',
  error: 'error',
  warning: 'warning',
  info: 'info'
}

/* ==========================================================================
  Loader Types
========================================================================== */
export const LOADER_HANDLER_TYPES = {
  page: 'pageLoader',
  submit: 'submitButtonLoader',
  table: 'tableLoader'
}

/* ==========================================================================
  All the navigation route Paths
========================================================================== */
export const ROUTE_PATHS = {
  // ----single routes------------
  home: '/',
  // holdem: '/holdem',
  plo5: '/plo5',
  plo6: '/plo6',
  HOLD_EM_PAGE: '/holdem',
  HOLD_EM_GAME_PAGE: '/holdem-table/:tableId',
}

/* ==========================================================================
  Game Ids
========================================================================== */
export const DEFAULT_GAME_ID = {
  HOLDEM: 1,
  PLO4: 2,
  PLO5: 3,
  PLO6: 4,
  SHORT_DECK: 5,
  TOURNAMENT: 6
}

/* ==========================================================================
  Player action status
========================================================================== */
export const POKER_GAME_PLAYER_ACTION_STATUS = {
  CALL: 'CALL',
  BET: 'BET',
  RAISE: 'RAISE',
  CHECK: 'CHECK',
  FOLD: 'FOLD',
  ALL_IN: 'ALL_IN'
}


/* ==========================================================================
  Card Deck (must match game engine CARD_DECK - IDs 1-52, shortString for mapping)
========================================================================== */
export const CARD_DECK = {
  1: { suit: 'Club', suitRank: 1, description: 'Two', longString: 'clubs-2', shortString: '2c', sort: 1, value: 2 },
  2: { suit: 'Club', suitRank: 1, description: 'Three', longString: 'clubs-3', shortString: '3c', sort: 2, value: 3 },
  3: { suit: 'Club', suitRank: 1, description: 'Four', longString: 'clubs-4', shortString: '4c', sort: 3, value: 4 },
  4: { suit: 'Club', suitRank: 1, description: 'Five', longString: 'clubs-5', shortString: '5c', sort: 4, value: 5 },
  5: { suit: 'Club', suitRank: 1, description: 'Six', longString: 'clubs-6', shortString: '6c', sort: 5, value: 6 },
  6: { suit: 'Club', suitRank: 1, description: 'Seven', longString: 'clubs-7', shortString: '7c', sort: 6, value: 7 },
  7: { suit: 'Club', suitRank: 1, description: 'Eight', longString: 'clubs-8', shortString: '8c', sort: 7, value: 8 },
  8: { suit: 'Club', suitRank: 1, description: 'Nine', longString: 'clubs-9', shortString: '9c', sort: 8, value: 9 },
  9: { suit: 'Club', suitRank: 1, description: 'Ten', longString: 'clubs-10', shortString: 'Tc', sort: 9, value: 0 },
  10: { suit: 'Club', suitRank: 1, description: 'Jack', longString: 'clubs-J', shortString: 'Jc', sort: 10, value: 0 },
  11: { suit: 'Club', suitRank: 1, description: 'Queen', longString: 'clubs-Q', shortString: 'Qc', sort: 11, value: 0 },
  12: { suit: 'Club', suitRank: 1, description: 'King', longString: 'clubs-K', shortString: 'Kc', sort: 12, value: 0 },
  13: { suit: 'Club', suitRank: 1, description: 'Ace', longString: 'clubs-A', shortString: 'Ac', sort: 13, value: 1 },
  14: { suit: 'Diamond', suitRank: 2, description: 'Two', longString: 'diamonds-2', shortString: '2d', sort: 1, value: 2 },
  15: { suit: 'Diamond', suitRank: 2, description: 'Three', longString: 'diamonds-3', shortString: '3d', sort: 2, value: 3 },
  16: { suit: 'Diamond', suitRank: 2, description: 'Four', longString: 'diamonds-4', shortString: '4d', sort: 3, value: 4 },
  17: { suit: 'Diamond', suitRank: 2, description: 'Five', longString: 'diamonds-5', shortString: '5d', sort: 4, value: 5 },
  18: { suit: 'Diamond', suitRank: 2, description: 'Six', longString: 'diamonds-6', shortString: '6d', sort: 5, value: 6 },
  19: { suit: 'Diamond', suitRank: 2, description: 'Seven', longString: 'diamonds-7', shortString: '7d', sort: 6, value: 7 },
  20: { suit: 'Diamond', suitRank: 2, description: 'Eight', longString: 'diamonds-8', shortString: '8d', sort: 7, value: 8 },
  21: { suit: 'Diamond', suitRank: 2, description: 'Nine', longString: 'diamonds-9', shortString: '9d', sort: 8, value: 9 },
  22: { suit: 'Diamond', suitRank: 2, description: 'Ten', longString: 'diamonds-10', shortString: 'Td', sort: 9, value: 0 },
  23: { suit: 'Diamond', suitRank: 2, description: 'Jack', longString: 'diamonds-J', shortString: 'Jd', sort: 10, value: 0 },
  24: { suit: 'Diamond', suitRank: 2, description: 'Queen', longString: 'diamonds-Q', shortString: 'Qd', sort: 11, value: 0 },
  25: { suit: 'Diamond', suitRank: 2, description: 'King', longString: 'diamonds-K', shortString: 'Kd', sort: 12, value: 0 },
  26: { suit: 'Diamond', suitRank: 2, description: 'Ace', longString: 'diamonds-A', shortString: 'Ad', sort: 13, value: 1 },
  27: { suit: 'Heart', suitRank: 3, description: 'Two', longString: 'hearts-2', shortString: '2h', sort: 1, value: 2 },
  28: { suit: 'Heart', suitRank: 3, description: 'Three', longString: 'hearts-3', shortString: '3h', sort: 2, value: 3 },
  29: { suit: 'Heart', suitRank: 3, description: 'Four', longString: 'hearts-4', shortString: '4h', sort: 3, value: 4 },
  30: { suit: 'Heart', suitRank: 3, description: 'Five', longString: 'hearts-5', shortString: '5h', sort: 4, value: 5 },
  31: { suit: 'Heart', suitRank: 3, description: 'Six', longString: 'hearts-6', shortString: '6h', sort: 5, value: 6 },
  32: { suit: 'Heart', suitRank: 3, description: 'Seven', longString: 'hearts-7', shortString: '7h', sort: 6, value: 7 },
  33: { suit: 'Heart', suitRank: 3, description: 'Eight', longString: 'hearts-8', shortString: '8h', sort: 7, value: 8 },
  34: { suit: 'Heart', suitRank: 3, description: 'Nine', longString: 'hearts-9', shortString: '9h', sort: 8, value: 9 },
  35: { suit: 'Heart', suitRank: 3, description: 'Ten', longString: 'hearts-10', shortString: 'Th', sort: 9, value: 0 },
  36: { suit: 'Heart', suitRank: 3, description: 'Jack', longString: 'hearts-J', shortString: 'Jh', sort: 10, value: 0 },
  37: { suit: 'Heart', suitRank: 3, description: 'Queen', longString: 'hearts-Q', shortString: 'Qh', sort: 11, value: 0 },
  38: { suit: 'Heart', suitRank: 3, description: 'King', longString: 'hearts-K', shortString: 'Kh', sort: 12, value: 0 },
  39: { suit: 'Heart', suitRank: 3, description: 'Ace', longString: 'hearts-A', shortString: 'Ah', sort: 13, value: 1 },
  40: { suit: 'Spade', suitRank: 4, description: 'Two', longString: 'spades-2', shortString: '2s', sort: 1, value: 2 },
  41: { suit: 'Spade', suitRank: 4, description: 'Three', longString: 'spades-3', shortString: '3s', sort: 2, value: 3 },
  42: { suit: 'Spade', suitRank: 4, description: 'Four', longString: 'spades-4', shortString: '4s', sort: 3, value: 4 },
  43: { suit: 'Spade', suitRank: 4, description: 'Five', longString: 'spades-5', shortString: '5s', sort: 4, value: 5 },
  44: { suit: 'Spade', suitRank: 4, description: 'Six', longString: 'spades-6', shortString: '6s', sort: 5, value: 6 },
  45: { suit: 'Spade', suitRank: 4, description: 'Seven', longString: 'spades-7', shortString: '7s', sort: 6, value: 7 },
  46: { suit: 'Spade', suitRank: 4, description: 'Eight', longString: 'spades-8', shortString: '8s', sort: 7, value: 8 },
  47: { suit: 'Spade', suitRank: 4, description: 'Nine', longString: 'spades-9', shortString: '9s', sort: 8, value: 9 },
  48: { suit: 'Spade', suitRank: 4, description: 'Ten', longString: 'spades-10', shortString: 'Ts', sort: 9, value: 0 },
  49: { suit: 'Spade', suitRank: 4, description: 'Jack', longString: 'spades-J', shortString: 'Js', sort: 10, value: 0 },
  50: { suit: 'Spade', suitRank: 4, description: 'Queen', longString: 'spades-Q', shortString: 'Qs', sort: 11, value: 0 },
  51: { suit: 'Spade', suitRank: 4, description: 'King', longString: 'spades-K', shortString: 'Ks', sort: 12, value: 0 },
  52: { suit: 'Spade', suitRank: 4, description: 'Ace', longString: 'spades-A', shortString: 'As', sort: 13, value: 1 }
}


/* ==========================================================================
  Extra Constants Variables
========================================================================== */
export const PAGINATION_LIMIT = 20
export const MIN_WITHDRAW_AMOUNT = 0.003
export const WITHDRAW_FEES = 0.000006
export const DEFAULT_PAGE_CALLS = 20
export const DEFAULT_TOP_BET_TYPE_LIMIT = 20
export const DEFAULT_MY_BETS_LIMIT = 20
export const DEFAULT_PRECISION_MONEY = 2
export const DEFAULT_AUTO_BET_COUNTER = 3
export const DEFAULT_BET_AMOUNT_SC = 1
export const DEFAULT_BET_AMOUNT_GC = 2500
export const TAB_SELECTION = Object.freeze({
  placed: Symbol('placed'),
  previous: Symbol('previous')
})
export const MIN_PAYOUT = {}

export const APPEND_TYPES = {
  ROUND_STOPPED: 'ROUND_STOPPED',
  ESCAPE: 'ESCAPE'
}

/* ==========================================================================
  Game Result
========================================================================== */
export const BET_RESULT = {
  WON: 'won',
  LOST: 'lost',
  CANCELLED: 'cancelled'
}

export const COIN_CURRENCY_ID = {
  GC: '1',
  SC: '2'
}

export const COIN_CURRENCY_CODES = {
  GC: 'GC',
  SC: 'SC'
}

/* ==========================================================================
  Wallet emit types
========================================================================== */
export const WALLET_EMIT_TYPES = {
  CREDIT: 'credit',
  DEBIT: 'debit',
  RESOLVE: 'resolve',
  DEFAULT: 'default'
}

export const PROVABLE_FAIR_TEXT = '"Provably fair" is a term that refers to a system or algorithm used in online gambling or gaming that can be mathematically verified to ensure that the results are fair and not manipulated in any way. It is a way for players to know that the game or gambling platform they are using is legitimate and not rigged against them.'

export const TOP_BET_TYPE = {
  BIGGEST_WIN: 'BIGGEST_WIN',
  HUGE_WIN: 'HUGE_WIN',
  MULTIPLIER: 'MULTIPLIER',
  GOLD_COINS: 'GC',
  SWEEPSTAKES_COINS: 'SC'
}



export const CURRENCY_SYMBOLS = {
  USD: '$'
}
export const CURRENCIES = {
  USD: { isFiat: true, precision: 2, symbol: '$', label: 'United States Dollar', value: 'USD', fileName: 'dollar-currency.svg' }
}
